import type markTaskAsComplete from '../../../../hosting-server/src/task/functions/markTaskAsComplete';
import { createServerHook } from '../../core/hooks/serverHooksCreators';

const useMarkTaskAsComplete =
    createServerHook<typeof markTaskAsComplete>('markTaskAsComplete');

export default useMarkTaskAsComplete;
